export default {
  account: {
    health_questionnaire: "Health questionnaire",
    setting: "Account settings",
    pwz: "medical licence",
    personal_data: "Your data",
    address: "Your address",
    addresses: "your details",
    addresses_and_invoices: "Preferred locations",
    collection_points: "Your diagnostic centers",
    childrens: "Your children",
    password: "Password",
    current_password: "Current password",
    new_password: "New password",
    confirm_password: "Repeat new password",
    update_data: "Edit your data",
    change_password: "Change your password",
    blocked: "You have been blocked",
    contact_administrator: "Contact the administrator",
    children: "Children assigned to your account ",
    welcome: "Hello",
    floor: "Floor",
    gate_code: "Code for the gate",
    additional_info: "Additional information",
    default_address: "Default address",
    remove_address_title: "Are you sure you want to remove the address?",
    add_new_address: "Add new address",
    add_new_invoice_data: "Add new invoice data",
    add_invoice_data: "Add new invoice data",
    add_new_collection_point: "Add a new diagnostic centre",
    edit_address: "Edit address",
    new_address: "New address",
    edit_invoice_data: "Edit invoice data",
    no_saved_addresses: "No saved addresses",
    no_saved_invoices_data: "No saved invoice data",
    check_your_address_is_correct: "Check that your address is correct.",
    no_assigned_children: "No assigned children",
    patient_data_summary: "Summary data of the person ordering the test",
    ask_invoice_data: "Ask for an invoice",
    download_invoice: "Download the invoice",
    doctor_short: "Dr",
    email: "E-mail",
    new_invoice_data: "New invoice details",
    remove_facility_alert: "Do you want to remove the collection facility?",
    remove_invoice_data_title: "Do you want to remove the collection facility?",
    doctor_label: "Doctor",
    doctor_consents: "Consents granted to the doctor",
    share_examinations_results:
      "Grant permission for access to your test results",
    doctor_consents_label: "Consent to access to test results",
    no_assigned_consents: "No requests for access to your test results",
    doctor_consent_content:
      "sent a request to access the history of your test results. Respond by selecting one of the options below.",
    doctor_consent_title: "Request for access to test results.",
    change_phone_number_modal_title: "Change of phone number",
    change_phone_number_modal_description:
      "Below, enter the code we sent to your new phone number.",
    profile_settings: "Profile settings",
    no_results:
      "The results will be visible here no earlier than 24 hours after the sample collection",
    no_tests:
      "The results will be visible here no earlier than 24 hours after the sample collection",
    no_tests_no_results_1: "You haven't purchased any tests yet,",
    no_tests_no_results_2: "and no referrals have been issued to you.",
    no_tests_no_results_3:
      "Take care of your health and purchase the tests today",
    scheduled_visits: "Scheduled visits",
    your_doctors: "Your Doctors",
    dashboard: "Dashboard",
    weight_loss: "Weight loss",
  },

  action: {
    change: "Change",
    see_details: "See details",
    see_doctor: "See doctor",
    see_referral: "See referral",
    go_back: "Return",
    save_changes: "Save changes",
    choose: "Select",
    chosen: "Selected",
    choose_facility: "Find a Test Center",
    continue: "Continue",
    save: "Save",
    clear: "Clean",
    return: "Back",
    filter: "Filter",
    withdraw_funds: "Withdraw funds",
    edit: "Edit",
    download: "Download",
    cancel: "Cancel",
    confirm: "Confirm",
    assign: "Assign",
    search: "Search",
    show_more: "Show more",
    add: "Add",
    accept: "Accept",
    reject: "Reject",
    preview: "Preview",
    pay: "Pay",
    pay_for_examinations: "Pay for the test",
    save_new_address: "Save new address",
    save_new_invoice_data: "Save your invoice details",
    approve: "Approve",
    expand: "expand",
    collapse: "collapse",
    send_mail: "Send mail",
    close: "Close",
    complete_the_form: "Complete the form",
  },

  auth: {
    dont_have_a_patient_account_create_one:
      "Don't have a Patient Account? Create one!",
    your_benefits: "Your benefits",
    benefits: {
      benefit_one: "Archive of test results",
      benefit_two: "Assistance in the selection of studies",
      benefit_three: "Interpretation of results",
      benefit_four: "Medical and dietary consultations",
      benefit_fife: "Prevention actions",
    },
    purchase_without_registration: "Purchase without registration",
    buy_as_a_guest: "Buy as a guest without creating an account",
    login_on_patient_account: "Log in to your Patient Account",
    create_doctor_account: "Create a Doctor's Account",
    create_account: "Create an account",
    enter_code: "Please enter the code you receive in the SMS message",
    enter_sms_code: "Please enter the code you receive in the SMS message",
    account_succesfull_created:
      "Congratulations! Your account has been created in GetLabTest",
    account_succesfull_created_page:
      "Your account has been created successfully",
    account_succesfull_created_page_1: "Your account",
    account_succesfull_created_page_2: "has been created successfully",
    account_succesfull_created_info:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    email: "E-mail address",
    first_name: "Name",
    go_back_to_login: "Back to Login",
    go_back_to_main: "Go back to main",
    have_account: "Already have an account?",
    last_name: "Surname",
    full_name: "First and last name",
    logout: "Logout",
    not_have_account: "Don't have an account yet?",
    not_have_account_create: "Don't have an account?",
    not_have_account_create_2: "Create one!",
    not_receive_code: "The code did not reach me",
    not_remember_password: "Forgot your password?",
    password: "Password",
    password_confirm: "Repeat password",
    password_remind: "Remind password",
    password_reset: "Reset password",
    password_update: "Change password",
    phone: "Phone number",
    pwz: "Medical licence no.",
    register: "Register",
    create_a_account: "Create a account",
    go_to_registration: "Go to registration",
    reset: "Set a new password to your portal account",
    send_reset_link: "We will send a password reset link to your email address",
    sent_reset_link:
      "We sent you an SMS with the verification code to the number",
    sent_reset_link_email:
      "We sent you an email with a link to reset your password.",
    password_reset_link_sended:
      "The link has been sent, wait a moment to receive a new link.",
    sent_reset_link_error:
      "The link has been sent, wait a moment to receive a new link.",
    reset_link_expired: "Your password reset link has expired",
    sign_in: "Log in",
    sign_up: "Sign up",
    enter_your_phone_number: "Enter your phone number",
    enter_your_pesel_number: "Enter your PESEL number",
    enter_birthday: "Enter your date of birth",
    processing_accept:
      "I confirm that these tests are for preventive and health improvement purposes only, not for paternity, forensic, insurance, cosmetic, or stem cell banking purposes.",
    processing_accept_2: "",
    processing_accept_3: "",
    marketing_accept:
      "I consent to the processing of my email address for sending the newsletter electronically.",
    accept_terms_1:
      "I accept the Terms for electronic health service contracts, allowing GetLabTest to perform services before the 14-day withdrawal period ends.",
    accept_terms_2: "Patient Terms of Use ",
    accept_terms_3: "",
    accept_terms_4: "accept_terms_4",
    sms: "SMS code",
    specialist_panel: "to the specialist panel",
    patient_panel: "to patient panel",
    verify: "Verify",
    pay_for_examinations: "to pay for tests",
    enter_email_and_password: "Enter your email and password,",
    to_create_account: "to create a portal account",
    enter_your_details_to_create_a_portal_account:
      "Enter your details, to create a portal account",
    sign_up_to_patient_panel: "Sign up to our patient panel",
    enter_phone_number: "Enter your phone number",
    enter_pesel: "Enter your pesel",
    login_by_pesel: "Register using your pesel",
    login_by_phone: "Register using your phone number",
    identity_card: "Proof No.",
    pesel: "Personal ID Number",
    current_password: "Current password",
    set_password: "Set password",
    salary: "Salary",
    patient_account: "to patient account",
    or: "or",
    to_pay_for_examinations: "to pay for the tests",
    checkboxes: {
      agree: "I agree with",
      marketing:
        "I agree to the use of my personal information for marketing purposes",
      terms: "Terms",
      service: "service",
      and: "and",
      privacy_policy: "Privacy Policy",
      no_pesel_number: "No PESEL number",
    },
    commission_options: {
      d15p0: "15% for the doctor, 0% for the patient",
      d10p5: "10% for the doctor, 5% for the patient",
      d5p10: "5% for the doctor, 10% for the patient",
      d0p15: "0% for the doctor, 15% for the patient",
      d5p5: "5% for the doctor, 5% for the patient",
    },
    birth_date: "Date of birth",
    day: "Day",
    month: "Month",
    year: "Year",
    gender: {
      title: "Gender",
      m: "Male",
      f: "Female",
    },
    services: {
      comprehensive_medical_services: "Comprehensive medical services",
      home_visits: "Home visits",
      online_purchase: "Purchase test online",
      discounts: "Discounts on tests and packages",
      consultations: "Medical and dietary consultations",
      analysis: "Analysis of test results and health trends",
      all_services: "All of 's services in one place",
    },
  },

  cart: {
    test_ordered: "Tests ordered",
    selected_examinations: "Selected tests",
    no_examinations: "You have not yet selected any tests for referral.",
    nurse_service: "Diagnostic Centre Collection Fee",
    covid_service: "COVID Nursing Service",
    total: "Total",
    your_commission: "Your salary",
    your_discount: "Discount",
    issue_referral: "Make a referral",
    edit_referral: "Edit referral",
    edit_referral_warning:
      "Editing this referral will issue a new referral and cancel the current referral.",
    pay_referral: "Pay",
    details: "Details",
    price_for_commuting_service: "Phlebotomist home visit & sample collection",
    pay_only_once: "You only pay once",
    your_examinations: "Your tests",
    your_online_appointments: "Your online appointments",
    pay_for_examinations: "Pay for tests",
    go_to_summary: "Go to summary",
    other_adults_test_results:
      "Other adults will receive the test results by logging on to the website",
    add_more_patients: "Add more patients",
    tests_unavailable_at_the_selected_collection_point:
      "test not available at the selected Diagnostic Centre.",
    please_select_a_different_collection_point: "Choose another point.",
    savings: "Save",
    confirm_remove_examination: "Are you sure you want to remove the test?",
    confirm_remove_appointment: "Are you sure you want to remove appointment?",
    confirm_remove_examination_discount:
      "This will remove the applied discount codes and accrued discounts.",
    next_step: "Next",
    attention: "Attention",
    loss_of_already_accrued_discounts_alert:
      "Deleting the test will result in the loss of already accrued discounts. Are you sure you want to do this?",
    select_a_city: "Select a city",
  },

  checkout: {
    chose_another_address: "Choose a different address",
    chose_another_invoice_data: "Select other data",
    no_default_address: "No default address",
    saved_addresses: "Saved addresses",
    saved_invoices_data: "Saved invoice data",
    cart_is_empty: "You do not have any added tests",
    see_examinations_catalog: "See the catalog of tests",
    summary: "Summary",
    address_details: "Address details ",
    provide_contact_information:
      "Provide contact information for the person ordering the tests",
    enter_data: "Enter data",
    visit_address: "Address",
    confirm_collection_address: "I confirm the Diagnostic Centre",
    collection_address: "Pickup address",
    your_collection_address: "Your chosen Diagnostic Centre",
    home_service_address: "home_service_address",
    data: "Data",
    additional_information: "Additional remarks",
    street: "Street Name",
    home_number: "House Number",
    premises_number: "Flat Number",
    zip_code: "PostCode",
    city: "City/Town",
    level: "Floor",
    gate_code: "Gate code",
    additional_comments: "Message",
    enter_the_code_for_the_gate:
      "Provide the gate code in case the patient or a household member cannot open it.",
    set_up_an_account_and_buy_examinations_faster:
      "I want to set up an account and buy tests faster",
    it_looks_like_you_already_have_an_account_in_our_store:
      "It seems like you already have an account in our store. Please provide your password and log in so that we can update your address",
    it_looks_like_dont_have_an_account_in_our_store:
      "Please create an account to buy and access your test results",
    main_page: "Homepage",
    remember_when_forget:
      "Remember, if you forget to buy tests, you will be able to buy them on the spot",
    your_location_is_not_yet_available_for_home_visits:
      "Home visits are not yet available in your location. You can go to one of our 500  locations for tests.",
    added_patients: "Added patients",
    ordered_tests: "Ordered tests",
    ordered_appointment: "Ordered appointment",
    appointment_scheduled_after_the_tests_performed:
      "The appointment will be scheduled after the tests are performed",
    date_of_the_visit: "Date of visit",
    choose_a_date_for_your_home_visit: "Select a home visit date",
    entire_order:
      "The execution of the entire order must take place during one visit. If you want to perform individual tests on different dates, please place separate orders for them.",
    choose_a_date: "Select a date",
    payment_method: "Payment method",
    choose_payment_method_for_examinations: "Select a payment method for test",
    choose_payment_method: "Select a payment method",
    fast_transfer: "Fast transfer",
    credit_card: "Payment card",
    name_and_surname: "Name as indicated on the card",
    card_number: "Payment card number",
    valid_to: "Valid until",
    card_code: "CVV2/CVC2 code",
    where_can_i_find_the_code: "Where can I find the code?",
    three_digits:
      "You can find the CVV2/CVC2 code on the back of the payment card - it is a 3-digit number.",
    no_examination_at_selected_point_info:
      "Test is not available at the selected point",
    home_service: "In-Home Service",
    collection_at_point: "Local Test Centers",
    selected_collection_point: "Selected Diagnostic Centre",
    chosen_date: "Selected date:",
    reservation_info_alert:
      "The selected appointment is booked for 15 min from the moment of selection",
    reservation_zip_code_error_alert: "The postal code entered is incorrect",
    confirm_collection_address_home: "Confirm the Collection address",
    srvice_address: "Service address",
    choose_one_of_our__points:
      "Choose one of our {number}  points to perform the test.",
    last_form: "last formalities",
    accept_terms_1: "I declare that I have read and accept the",
    accept_terms_1_2: "Terms of service",
    accept_terms_1_3: "#",
    accept_terms_2:
      "I hereby declare that the laboratory tests ordered by me are performed to provide the person undergoing the tests with medical care in terms of preventive health as well as preservation, saving, restoration and improvement of health. I accept the test methods used in the laboratory and the subcontractor selected from the current register. I further declare that the tests ordered will not be used for the purposes related to medical care in the field of:",
    accept_terms_2_2:
      "1.   genetic testing aimed at the establishment of paternity or postmortem identification.",
    accept_terms_2_3:
      "2.   tests, diagnoses, opinions or activities carried out for forensic medicine purposes.",
    accept_terms_2_4:
      "3.   tests for the purpose of obtaining a disability pension or applying for an insurance policy.",
    accept_terms_2_5:
      "4.   plastic surgery and other cosmetic procedures not aimed at restoring or improving health.",
    accept_terms_2_6: "5.   umbilical cord blood and stem cell banking. ",
    accept_terms_3:
      "I declare that I consent to the performance by GetLabTest with its registered  of a service resulting from a distance contract concluded with GetLabTest with its registered  before the expiry of the 14-day period for withdrawal from the concluded contract.",
    accept_terms_4:
      "I declare that I have been informed and acknowledge that as soon as the service has been fully performed and the contractual performance has been fulfilled by GetLabTest with its registered , I shall lose my right to withdraw from the contract. ",
    accept_terms_5:
      "I declare that I have been informed that my consent to the performance of the service by GetLabTest with its registered  before the expiry of the 14-day withdrawal period shall give rise to an obligation to pay remuneration for the services rendered until the moment of withdrawal, pursuant to Art. 35 of the Act of 30 May 2014 on consumer rights.",
    is_order_patient: "The patient is the person ordering the tests",
    collection_point_is_no_longer_active:
      "Selected Point of Collection no longer active.",
    change_the_collection_point: "Change the Diagnostic Centre",
    check_all: "Check all",
  },

  collection_facility: {
    collection_facility_title:
      "Home visits are not available at your location yet, however you can go to one of our 400  locations to do your research.",
    collection_facility_text:
      "Set for which point you want to have the price list of the laboratory tests shown. you can change it at any time in your profile.",
    search_placeholder: "City, street or postal code",
    search_placeholder_no_code: "Enter city or street",
    current_location_error:
      "You did not allow your browser to download the location. Please try again.",
    hide_list: "Hide the list",
    show_list: "Show the list",
    opening_hours: "Opening hours",
    default_point: "Default Diagnostic Centre",
    no_assigned_collection_points: "No saved Diagnostic Centers",
    show_filters: "Show filters",
    hide_filters: "Hide filters",
    show_on_map: "Show on map",
    set_the_route: "Determine the route",
  },

  dashboard: {
    inaccessible_facility:
      "Your Diagnostic Centre is inactive or unable to perform tests.",
    inaccessible_facility_btn: "Change the Diagnostic Centre",
    commission_info:
      "The salary is the sum of the amounts payable for orders executed",
  },

  doctor_status: {
    blocked: "Blocked",
    active: "Active",
    inactive: "Inactive",
    all: "All",
  },

  empty_list: {
    referrals: "The referral list is empty.",
    doctors: "The list of doctors is empty.",
    patients: "The patient list is empty.",
    invoices: "The list of invoices is empty.",
    visits: "The list of visits is empty.",
  },

  error: {
    weight: {
      is_to_small_for_health_bmi:
        "Your target weight is too small for your health BMI.",
      required: "Weight code is required",
      must_be_greater_than_0: "A weight must be greater than 0.",
      is_greater_than_current_weight:
        "Weight cant be greater than current weight",
    },
    date_time: {
      invalid_date: "Value is not a valid date.",
      does_not_match_the_format: "Value not match the date format.",
      must_be_a_date_before_or_equal_to: {
        now: "Value must be a date before or equal to now",
      },
    },
    delivery_address: {
      zip_code: {
        required: "Zip code is required",
        must_not_be_greater_than_255:
          "Zip code must not be longer than 255 characters",
      },
      city: {
        required: "City is required",
        must_not_be_greater_than_255:
          "City must not be longer than 255 characters",
      },
      street: {
        required: "Street is required",
        must_not_be_greater_than_255:
          "Street must not be longer than 255 characters",
      },
      home_number: {
        required: "Home number is required",
        must_not_be_greater_than_255:
          "Home number must not be longer than 255 characters",
      },
      premises_number: {
        must_not_be_greater_than_255:
          "Premises number must not be longer than 255 characters",
      },
      level: {
        must_not_be_greater_than_255:
          "Level must not be longer than 255 characters",
      },
      gate_code: {
        must_not_be_greater_than_255:
          "Gate code must not be longer than 255 characters",
      },
      additonal_comments: {
        must_not_be_greater_than_255:
          "Additional comments must not be longer than 255 characters",
      },
    },
    file: {
      must_not_be_greater_than_10240: "The file must not exceed 10MB.",
      must_be_a_file: "The file is required.",
    },
    invoice_data: {
      company_name: {
        required: "Company name is required.",
        required_if_empty: {
          individual: "Company name is required.",
        },
      },
      nip: {
        required: "VAT Registration Number is required.",
        digits:
          "VAT Registration Number must be 10 in length and contain only numbers.",
        required_if_empty: {
          individual: "VAT Registration Number is required.",
        },
        must_be_a_valid_vat_number:
          "VAT Registration Number must be a valid UK VAT number (e.g., GB123456789)",
      },
      street: {
        required_if_empty: {
          want_invoice: "Street is required.",
        },
      },
      zip_code: {
        required_if_empty: {
          want_invoice: "Post Code is required.",
        },
      },
      city: {
        required_if_empty: {
          want_invoice: "City is required.",
        },
      },
      first_name: {
        required: "First name is required.",
      },
      last_name: {
        required: "Last Name is required.",
      },
    },
    discount_code: {
      selected_invalid: "The specified code does not exist.",
      expired: "Code inactive",
      used: "The given code has already been used",
      minimum_order_amount: "The minimum order amount has not been met",
      requirements: "Code does not apply to selected examinations",
    },
    facility_id: {
      required: "It is required to select a Diagnostic Centre",
      required_if_empty: {
        home_service: "It is required to select a Diagnostic Centre",
        is_home_service: "It is required to select a Diagnostic Centre",
      },
    },
    is_terms_accepted: {
      accepted: "Consent is required.",
    },
    auth: {
      blocked:
        "Your account has been blocked. Please contact the administrator.",
      required: "Login or registration is required to place an order",
    },
    name: {
      required: "First and last name is required.",
    },
    sex: {
      required: "Gender is required.",
    },
    gender: {
      required: "Gender is required.",
    },
    accept_data_processing: {
      accepted: "Consent is required.",
    },
    g_recaptcha_response: {
      required: "Recaptcha is invalid",
      recaptcha: "Recaptcha is invalid",
    },
    agree_contact: {
      accepted: "Consent is required.",
    },
    accept_terms: {
      accepted: "Consent is required.",
    },
    accept_marketing: {
      accepted: "Consent is required.",
    },
    code: {
      required: "A sms code is required.",
      incorrect: "The code you entered is invalid.",
    },
    email: {
      already_taken: "The email you provided has already been used.",
      credentials_not_match: "The credentials are invalid.",
      email: "The email must be a valid email address.",
      required: "Email is required.",
      selected_invalid: "The specified email does not exist in the database.",
      require_authenticated: "The user must be logged in",
    },
    pesel: {
      required: "Personal ID number is required.",
      already_taken: "The personal ID number provided has already been used.",
      digits: "The personal ID number must be 11 in length.",
      invalid: "Incorrect personal ID number.",
      invalid_date: "Incorrect personal ID number.",
      child_incorrect: "child_incorrect",
      child_invalid: "child_invalid",
      birth_date_diffrent: "birth_date_diffrent",
      required_if_empty: {
        birth_date: "Personal ID number or date of birth is required.",
      },
      required_when_not_present: {
        phone_number: "Phone number or pesel is required.",
      },
      incorrect: "We can't find the user with the given identity pesel.",
      distinct:
        "The same pesel number is repeated with other patients in the order.",
    },
    birth_date: {
      required: "Date of birth is required.",
      required_if_empty: {
        pesel: "Personal ID number or date of birth is required.",
      },
      must_be_date_after_or_equal:
        "Date of birth must be greater than or equal to 01/01 1900.",
      must_be_a_date_before: "It is not possible to choose this date of birth.",
      invalid_date: "Date of birth is not a valid date.",
      incorrect: "Date of birth and peselas are different",
      child_incorrect: "child_incorrect",
    },
    first_name: {
      required: "First name is required.",
      required_if_empty: {
        individual: "First name is required.",
      },
    },
    last_name: {
      required: "Last Name is required.",
      required_if_empty: {
        individual: "Last Name is required.",
      },
    },
    main_medical_category_id: {
      required: "Please select categories.",
    },
    current_password: {
      required: "The current password is required.",
      at_least_characters:
        "The current password must be at least 8 characters long.",
      invalid_format:
        "The current password must contain at least one lowercase letter, one uppercase letter, and one number.",
      incorrect: "The current password is incorrect.",
      is_required_when: {
        current_password: {
          is_present:
            "Current password is required when a new password is entered",
        },
      },
    },
    password: {
      required: "A password is required.",
      at_least_characters: "The password must be at least 8 characters long.",
      invalid_format:
        "The password must contain at least one lowercase letter, one uppercase letter, and one number.",
    },
    password_confirm: {
      required: "Password confirmation is required.",
      must_match: "The password and password confirmation must be the same.",
      is_required_when: {
        current_password: {
          is_present:
            "Repeat new password is required when a new password has been entered",
        },
      },
    },
    phone_number: {
      already_taken: "The phone number provided has already been used.",
      required: "Phone number is required.",
      digits: "The phone number must be 9 in length.",
      incorrect: "The phone number is incorrect.",
      required_when_not_present: {
        pesel: "Phone number or pesel is required.",
      },
      distinct: "The phone number provided has already been used",
      accepted: "Incorrect phone number",
    },
    phone_is_valid: {
      accepted: "Phone number is incorrect",
    },
    national_number: {
      required: "Phone number is required.",
    },
    national_phone_number: {
      required: "Phone number is required.",
    },
    pwz: {
      required: "Medical licence no. is required",
    },
    company_name: {
      required: "Company name is required.",
      required_if_empty: {
        individual: "Company name is required.",
      },
    },
    nip: {
      required: "VAT Registration Number is required.",
      digits: "VAT Registration Number must be 10 in length.",
      required_if_empty: {
        individual: "VAT Registration Number is required.",
      },
    },
    street: {
      required: "Street is required.",
    },
    house_number: {
      required: "Building number is required.",
    },
    home_number: {
      required: "House number is required.",
    },
    zip_code: {
      required: "Post Code is required.",
      invalid: "The postal code is incorrect.",
    },
    postal_code: {
      required: "Post Code is required.",
    },
    city: {
      required: "Locality is required.",
    },
    account_number: {
      required: "A bank account number is required.",
      invalid: "The bank account number is incorrect.",
    },
    agree1: {
      accepted: "Consent is required.",
    },
    identity_card: {
      required: "ID card number is required.",
    },
    title: {
      required: "Title is required.",
    },
    message: {
      required: "Message content is required.",
    },
    commission_option: {
      required: "The salary option is required.",
      selected_invalid: "The salary option must be one of the options above.",
    },
    is_verify:
      "The account with the phone number you have provided already exists.",
    reservation_date_not_available:
      "The selected appointment time is not available.",
    exist: {
      phone_number_exist:
        "The phone number provided is not consistent with the rest of the patient's data",
      pesel_exist: "The PESEL number provided has already been used",
      more_than_one_person_with_same_peseland_phone_number:
        "The PESEL and phone number provided  have already been used",
      person_same_pesel_in_database_with_different_phone_number:
        "The PESEL number provided has already been used",
      person_same_phone_number_in_database_with_different_pesel:
        "The phone number provided has already been used",
      pesel_invalid: "The PESEL number is incorrect",
      phone_number_invalid: "The phone number is incorrect.",
      user_or_correct_data:
        "The phone number provided is not consistent with the rest of the patient's data",
    },
    orderForPatient: {
      email: {
        required: "Email is required.",
        email: "The email must be a valid email address.",
      },
      national_number: {
        required: "Phone number is required.",
      },
      first_name: {
        required: "First name is required.",
      },
      last_name: {
        required: "Last Name is required.",
      },
      gender: {
        required: "Gender is required.",
      },
      birth_date: {
        required: "Date of birth is required.",
      },
    },
    address: {
      zip_code: {
        required_if_empty: {
          home_service: "Postal code is required",
          is_home_service: "Postal code is required",
        },
      },
      street: {
        required_if_empty: {
          home_service: "Street is required",
          is_home_service: "Street is required",
        },
      },
      home_number: {
        required_if_empty: {
          home_service: "House number is required",
          is_home_service: "House number is required",
        },
      },
      city: {
        required_if_empty: {
          home_service: "City is required",
          is_home_service: "City is required",
        },
      },
    },
    acceptFacility: {
      required: "Confirmation of the Diagnostic Centre is required",
    },
    acceptFacilityHome: {
      checked: "Confirmation of the Download Address is required",
    },
    update: {
      pesel_invalid: "Pesel cannot be edited",
    },
    accept_terms_1: {
      required: "Consent is required.",
    },
    accept_terms_2: {
      required: "Consent is required.",
    },
    accept_terms_3: {
      required: "Consent is required.",
    },
    accept_terms_4: {
      required: "Consent is required.",
    },
    accept_terms_5: {
      required: "Consent is required.",
    },
    date_to: {
      before_date_from: "Wrong date range",
    },
    examinations: {
      exist: {
        active_user_weight_loss:
          "You won’t be able to start a new program until your current one is complete",
      },
      selected_invalid: "Selected test not available in shop",
    },
  },

  error_page: {
    ups: "Oops, something went wrong. Wait a moment or try refreshing the page.",
    refresh: "Refresh",
  },

  examinations: {
    package: "Package",
    no_examinations: "No tests.",
    no_packages: "No packages.",
    no_services: "No tests or packages.",
    additional: "Additional tests",
    searched_examination: "Searching for a test",
    searched_package: "Package you are looking for",
    package_details: "Package details",
    examinaiotn_details: "Details of the test",
    search_results_for: "Search results for",
  },

  filters: {
    status: "Status",
    referral_number: "Referral number",
    patient: "Patient",
    doctor: "Doctor",
    price: "Price",
    commission: "Salary",
    date_of_issue: "Date of issue",
    cost: "Cost of the test",
    patient_discount_percent: "Discount percentage",
  },

  patient_discount_percent: {
    zero: "0 %",
    five: "5 %",
    ten: "10 %",
    fifteen: "15 %",
    all: "All",
  },

  homepage: {
    doctor: "Doctor",
    patient: "Patient",
    admin: "Admin",
    switch_roles: "Switch roles",
  },

  layouts: {
    main_page: "Main page",
    faq: "FAQ",
    contact: "Contact",
    about_us: "About us",
    offer: "Offers",
    catalog: "Tests",
    packages: "Packages",
    cart: "Checkout",
    account: "Your account",
    results: "Results & Referrals",
    weight_loss: "Weight loss",
    doctor_referral: "Referral from a doctor",
    search: "Search results",
    doctor: "Provider",
    patient: "Patient",
    discount: "UP TO",
    discount_2: "-20",
    discount_3: "% ON ALL TEST PACKAGES –",
    discount_4: "CHECK",
    receive_results: "Results & Referrals",
    collection_points: "Locations",
    order_detail: "Order details",
    retry_payment: "Retry payment",
    title: " at home",
  },

  medical_categories: {
    general_practitioner: "General Practitioner",
    allergist: "Allergist",
    pediatric_allergist: "Paediatric Allergist",
    andrologist: "Andrologist",
    anesthesiologist: "Anesthesiologist",
    angio_surgeon: "Angio-surgeon",
    angiologist: "Angiologist",
    audiologist: "Audiologist",
    bariatra: "Bariatrician",
    forensic_expert: "Forensic Expert",
    surgeon: "Surgeon",
    pediatric_surgeon: "Pediatric Surgeon",
    thoracic_surgeon: "Thoracic Surgeon",
    vascular_surgeon: "Vascular Surgeon",
    plastic_surgeon: "Plastic Surgeon",
    dental_surgeon: "Dental Surgeon",
    maxillofacial_surgeon: "Maxillofacial Surgeon",
    dermatologist: "Dermatologist",
    pediatric_dermatologist: "Paediatric Dermatologist",
    diabetologist: "Diabetologist",
    pediatric_diabetologist: "Paediatric Diabetologist",
    diagnostic: "Diagnostician",
    dietician: "Dietician",
    endocrinologist: "Endocrinologist",
    pediatric_endocrinologist: "Paediatric Endocrinologist",
    physiatrist: "Physiatrist",
    pediatric_physiatrist: "Paediatric Physiatrist",
    phlebologist: "Phlebologist",
    gastrologist: "Gastrologist",
    pediatric_gastrologist: "Paediatric Gastrologist",
    geneticist: "Geneticist",
    geriatrician: "Geriatrician",
    gynecologist: "Gynaecologist",
    pediatric_gynecologist: "Paediatric Gynaecologist",
    hematologist: "Haematologist",
    pediatric_hematologist: "Paediatric Haematologist",
    hepatologist: "Hepatologist",
    dental_hygienist: "Dental Hygienist",
    hypertensiologist: "Hypertensiologist",
    histopathologist: "Histopathologist",
    immunologist: "Immunologist",
    internist: "Internist",
    cardiac_surgeon: "Cardiac surgeon",
    cardiologist: "Cardiologist",
    pediatric_cardiologist: "Paediatric Cardiologist",
    laryngologist: "Laryngologist",
    pediatric_laryngologist: "Paediatric Laryngologist",
    infectious_diseases_physician: "Infectious Diseases Physician",
    occupational_medicine_physician: "Occupational Health Physician",
    doctor_of_emergency_medicine: "Emergency Medicine Physician",
    physician_of_medical_rehabilitation: "Medical Rehabilitation Physician",
    family_doctor: "Family Doctor",
    sports_doctor: "Sports Doctor",
    sports_medicine_physician: "Sports medicine physician",
    a_doctor_in_the_process_of_specialization:
      "Doctor in the course of specialisation",
    doctor_without_specialization: "Doctor without specialisation",
    logopedist: "Logopedist",
    nephrologist: "Nephrologist",
    pediatric_nephrologist: "Paediatric Nephrologist",
    neonatologist: "Neonatologist",
    neurosurgeon: "Neurosurgeon",
    pediatric_neurosurgeon: "Paediatric Neurosurgeon",
    neurologist: "Neurologist",
    pediatric_neurologist: "Paediatric Neurologist",
    ophthalmologist: "Ophthalmologist",
    pediatric_ophthalmologist: "Paediatric Ophthalmologist",
    oncologist: "Oncologist",
    pediatric_oncologist: "Paediatric Oncologist",
    optometrist: "Optometrist",
    orthodontist: "Orthodontist",
    orthopedist: "Orthopaedist",
    pediatric_orthopedist: "Paediatric Orthopaedist",
    orthoptist: "Orthoptist",
    osteopath: "Osteopath",
    pathomorphologist: "Pathomorphologist",
    pediatrician: "Paediatrician",
    perinatologist: "Perinatologist",
    nurse: "Nurse",
    obstetrician: "Obstetrician",
    midwife: "Midwife",
    proctologist: "Proctologist",
    prosthetist: "Prosthetist",
    psychiatrist: "Psychiatrist",
    child_psychiatrist: "Child Psychiatrist",
    psychologist: "Psychologist",
    child_psychologist: "Child psychologist",
    psycho_oncologist: "Psycho-oncologist",
    psychotherapist: "Psychotherapist",
    psychotraumatologist: "Psychotraumatologist",
    pulmonologist: "Pulmonologist",
    pediatric_pulmonologist: "Paediatric Pulmonologist",
    radiologist: "Radiologist",
    radiation_therapist: "Radiation Therapist",
    rheumatologist: "Rheumatologist",
    pediatric_rheumatologist: "Paediatric Rheumatologist",
    sexologist: "Sexologist",
    specialist_in_aesthetic_medicine: "Specialist in aesthetic medicine",
    dentist: "Dentist",
    pediatric_dentist: "Paediatric Dentist",
    transplantologist: "Transplantologist",
    coach: "Coach",
    ultrasonograph: "Ultrasonographer",
    urologist: "Urologist",
    pediatric_urologist: "Paediatric Urologist",
    venereologist: "Venereologist",
    main_category: "Specialisation",
    list: "Specialisations",
    all: "All",
  },

  messages: {
    code: {
      resend: "The code was sent again.",
      resend_error: "An error occurred while submitting the code.",
      to_many_hour_attemps: "You used your 3 attempts. Try again in an hour.",
      to_many_day_attemps:
        "You used the maximum number of attempts for one day. Try again tomorrow.",
    },
    edit: {
      success: "The changes were recorded.",
      failure: "An error occurred. Changes were not saved.",
    },
    save: {
      success: "Saved successfully.",
      failure: "An error occurred. Failed to save.",
    },
    sms: {
      success: "The text message was sent again.",
      failure: "An error occurred. The text message has not been sent again.",
    },
    send: {
      failure: "An error occurred. The message could not be sent.",
    },
    payment_token: {
      failure:
        "An error occurred. Please try again or contact your administrator.",
    },
    permission: {
      failure: "It cannot be done.",
    },
    download: {
      failure: "An error occurred while downloading the file.",
      no_invoice: "No invoices for the selected month.",
    },
    delete: {
      success: "Deleted successfully.",
      failure: "An error occurred. Failed to delete.",
    },
    error_code: {
      401: "Unauthorized access",
      403: "You do not have rights to the resource",
      410: "Expired",
    },
  },

  not_found_page: {
    error: "Error",
    not_found: "Page Not Found, But Health Insights Await!",
    not_found_content:
      "Seems like this page took a day off. Let's get you back on track to discover the wonders of digital healthcare.",
    go_back: "Go to the main page",
  },

  pages: {
    account: "Account settings",
    history_orders: "Referral history",
    my_settlements: "My accounts",
    doctors: "Doctors",
    referrals: "Referrals",
    invoices: "Invoices",
    your_referrals: "Your referrals",
  },

  patients: {
    add_kid: "Add another child (5-17 years)",
    add_adult: "Add another adult",
    add_patient: "Add a patient",
    edit_data: "Provide contact details of the person ordering the tests",
    data: "Provide contact details of the person ordering the tests",
    add_patient_to_be_able_to_assign_examinations:
      "Add a patient to be able to assign tests to them",
    assign_selected_examination_to_a_patient:
      "Assign the selected test to a patient",
    up_to_5_patients_can_be_added: "A maximum of 5 patients can be added",
    enter_date_of_birth: "Date of birth",
    assigned: "Assigned to",
    age_range: "Age range",
    kid: "Child (5-17 years)",
    adult: "Adult",
    remove_patient: "Delete patient",
    sign_in_to_add_other_person_data:
      "Log in or enter the details of the person for whom you are ordering the test",
    you_added_max_number_of_people:
      "You have added the maximum number of people",
    patient_in_system: "The Patient is already in our system",
  },

  referral_status: {
    patient: {
      issued: "New",
      paid: "Paid",
      canceled: "Canceled",
      completed: "Done Results",
      partial_results: "Partial Results",
    },
  },

  prescription_status: {
    to_do: "New",
    edited: "New",
    done: "Fulfilled",
    to_send: "To send",
    sent: "Sent",
  },

  referrals: {
    enter_study_name: "Enter a test name",
    referral: "Referral",
    number_short: "no.",
    examinations: "Tests/packages",
    date_of_issue: "date of issue",
    date_of_test: "date of test",
    exact_price:
      "You can find out the exact price by selecting a Diagnostic Centre",
    doctor: "doctor",
    number: "Referral no.",
    issued_on: "Issued on",
    see_results: "See test results",
    commissioned_examinations: "Commissioned tests",
    patient: "Patient",
    phone_number: "Phone number",
    pesel: "Personal ID number",
    payment: "Payment",
    commission: "Your salary",
    add_or_choose_patient:
      "Fill in the data for a new patient or find your patient in the list",
    issue_referrals: "Make referrals",
    patient_list: "List of patients",
    choose_patient: "Select a patient from the list",
    full_name: "First and last name",
    search_patient: "Enter your name, pesel or phone number",
    send_sms_again: "Send sms again",
    edit_issued_referral: "Edit a commissioned test",
    issued_referral_text_part1:
      "You have made a referral. We have sent a text message to the patient with instructions to complete the order.",
    issued_referral_text_part2:
      "You will be paid when the patient pays for the referral.",
    referral_for_examination: "Ordering laboratory tests",
    referral_for_examination_text:
      "Printed orders can be filled by your patient directly at  laboratories. Payment will be made or online",
    print_referral: "Print referral",
    collection_facilities: "Points of collection",
    collection_facilities_text:
      "Find out where your patient can complete the referral",
    see_collection_facilities: "See Diagnostic Centers.",
    examination_findings: "Results of test",
    examination_findings_text:
      "Test results will be available upon completion of the referral",
    unavailable: "Not available",
    waiting_for_payment: "Waiting for payment",
    waiting_for_commissions: "Waiting for the salary",
    price_online_payment: "Price for online payment at  Online.pl",
    price_facility_payment: "Price for payment at point of collection ",
    commission_after_purchase:
      "Salary will be calculated after the patient buys the referral",
    no_referrals: "You do not have referrals made.",
    issue_referral: "Make a referral for testing",
    popular_examinations: "Most frequently selected tests",
    package: "Package",
    added: "Added",
    number_of_referrals: "Number of referrals",
    average_number_of_referrals: "Average number of referrals",
    average_price_of_referral: "Average referral price",
    top_doctors: "Physicians who made referrals for the highest amount:",
    your_facility: "Your Diagnostic Centre",
    choose_examinations: "Choose tests",
    additionally_examinations:
      "If you wish, you may additionally perform other tests",
    ordered_examinations: "Reffered tests",
    change: "Change data and resend referral",
    dates: "Dates",

    tabs: {
      packages: "Packages",
      examinations: "Tests",
    },

    table: {
      id: "Referral ID",
      date: "Date",
      full_name: "First and last name",
      identity_card: "ID card number",
      status: "Status",
      phone: "Phone",
      number_of_examinations: "Number of tests",
      commission: "Salary",
      show: "See the referral",
      show_patient: "See the patient",
      code: "Post Code",
      city: "City",
      street: "Street",
      cost: "Cost of test",
      pesel: "Personal ID number",
      patient_discount_percent: "Discount percentage",
      patient_discount: "Discount",
    },
    from_doctor: "Order from doctor no.",
  },

  results: {
    download_pdf: "Download results in PDF",
    back_to_referral: "Back to referral",
    choose_examination: "Select a test to view results",
    lab: "Diagnostic Centre",
    date_of_result_collection: "Date the result was collected",
    referral_number: "Referral number",
    examinations_for: "Test for",
    date_of_issue: "Date of refferal",
    doctor: "Doctor",
    doctor_referral: "Order from doctor",
    sport_referral: "Referral from sport",
    date_of_collection: "Date of test",
    home_visit_address: "Address of home visit",
    collection_point_service: "Diagnostic Centre",
    order_no: "Order no.",
    all: "All",
    need_review: "Need review",
    expected_range: "Expected range",
    description_of_tests_during_preparation:
      "Your test descriptions are being prepared",
    we_will_notify_you_by_SMS_when_they_are_ready:
      "We will notify you by SMS when they are ready.",
    recommendations: "Recommendations",
    make_an_appointment_to_discuss_the_results:
      "Make an appointment to discuss the results with your doctor",
    make_an_appointment: "Make an appointment",
    description_titles: {
      profile: "Profile",
      follow_up_plan: "Follow-Up Plan",
      lifestyle_modifications: "Lifestyle modifications",
      results: "Results",
      health_risk_assessment: "Health risk assessment",
      summarize_for_patient_communication: "Doctor's Notes",
    },
  },

  select_time: {
    current_month: "Current month",
    previous_month: "Previous month",
    last_90_days: "The last 90 days",
    last_6_months: "Last 6 months",
    current_year: "Current year",
    selected_from: "Select from calendar",
  },

  titles: {
    your_finances: "Your finances",
    your_stats: "Your statistics",
    stats: "Statistics",
    top_doctors: "Top Doctors",
  },

  your_finances: {
    to_pay: "To pay",
  },

  your_referrals: {
    see_results: "See results",
    pay: "Pay for your tests",
    see_summary: "See summary",
    just_paid: "You have already paid for this referral.",
    go_to_facility: "Go to the collection center to get your tests done.",
  },
  documents: {
    terms: "Terms of service",
    privacy_policy: "Privacy Policy",
    patient_terms_of_use: "Patient Terms of Use",
  },

  your_settlements: {
    user_full_name: "First and last name",
    address: "Address",
    billing_data: "Invoice data",
    edit_billing_data: "Edit invoice details",
    my_settlements: "My settlements",
    verify_data_title: "Verify your data",
    verify_data_text:
      "Enter billing information to be able to bill wages on referrals issued",
    company_data_title: "Company data",
    company_name: "Company name",
    nip: "VAT Registration Number",
    free_from_vat_title: "Are you exempt from VAT?",
    free_from_vat:
      "I declare that I am entitled to the tax exemption provided for in Article 113 paragraph 1 of the VAT Act.",
    address_title: "Address",
    street: "Street",
    house_number: "Building number",
    flat_number: "Premises number",
    postal_code: "Post Code",
    city: "Town",
    account_number_title: "Bank account number",
    account_number: "Bank account number",
    verify_account: "Verify your account",
    your_invoices: "Your invoices",

    checkboxes: {
      check_all: "Select all",
      agree_terms: "I declare that I have read and accept",
      terms: "Terms",
      marketing:
        "I agree to the sending of commercial and marketing information via electronic means of communication.",
      agree3:
        "Donec dolor mi, interdum vel arcu vel, gravida sollicitudin est. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed accumsan dui et sollicitudin porttitor",
      agree4:
        "Donec sed lacus leo. Fusce fermentum sem sed odio luctus, eu sollicitudin massa elementum. Maecenas pellentesque ligula libero, vel condimentum sem lobortis et",
    },

    invoice: {
      date: "Date",
      number: "Invoice number",
      amount: "Amount",
      download: "Download the invoice",
      i_want_to_receive_an_invoice: "I want to receive an invoice",
      what_entity: "What entity will the invoice be issued to?",
      person: "Individual person",
      company_or_institution: "Company or institution",
      company_name: "Company name",
      additional_info:
        "The invoice will be issued by the 15th of the following month. You will receive an email when the invoice is ready for download in your Patient account",
    },
  },

  your_stats: {
    issued_referrals: "Referrals issued",
    paid_referrals: "Paid referrals",
    completed_referrals: "Completed referrals",
    canceled_referrals: "Cancelled referrals",
    commission: "Salary",
    cost: "Cost of testing",
  },
  payment: {
    made: "Payment made.",
    canceled: "Payment cancelled.",
    advance: "Waiting for payment confirmation.",
    returned: "Payment returned.",
    go_to_dashboard: "Go to main panel",
    retry_payment: "Re-payment",
    something_went_wrong: "Something went wrong",
    try_again: "Try again",
    contact_us: "Retry the payment or contact us",
    payment_error:
      "We apologize, an unexpected payment error has occurred. Please try to make the payment again or contact us at",
    order_paid: "Your order has been paid for.",
    order_waiting_paid: "Your order is pending payment.",
    thanks: "Thank you!",
    realize:
      "To complete the order, visit the Diagnostic Centre of your choice and enter the transaction code for easy registration. The order must be completed within 60 days of purchase.",
    our_consultant:
      "Your order has been paid for. Our consultant will come to the address you provided on the following date and time:",
    transaction_code: "Transaction code",
    facility: "Point of collection",
    monday_friday: "Mon - Fri",
    saturday: "Sat",
    fetch_status_error_msg: "There is a problem with loading the order status",
    check_status_again: "Check the status again",
    buy_additional_examinations: "Buy additional tests",
  },

  home: {
    find_a_examination_that_interests_you: "Find an test that interests you",
    examination_packages: "Test packages",
    the_most_popular_packages: "The most popular test packages",
    other_packages: "Other test packages",
    examinations: "Tests",
    the_most_popular_examinations: "The most frequently selected tests",
    other_examinations: "Other tests",
    examinations_categories: "Categories of tests",
    packages_categories: "Categories of test packages",
    what_examination_are_you_looking_for:
      "What kind of test are you looking for?",
    create_own_package: "Create own package",
    own_package_info:
      "This test is included in custom packages - which you can create yourself at a discount",
  },

  own_packages: {
    choose_examination_to_get_discount:
      "Choose from 5 to 15 tests and buy them at a discount of up to&nbsp;-25%",
    own_packages_alert:
      "You can create a custom package by selecting tests from the list below.",
    primary_examinations: "Primary tests",
    profiled_examinations: "Profiled tests",
    create_own_package: "Create your test package at a discount",
    own_package: "Custom package",
    your_own_package: "Your custom test package",
    you_got_the_maximum_discount:
      "You have obtained the maximum discount of 25%",
    add_at_least: "Add",
    examinaions_to_receive_a_discount: "Tests & Unlock a ",
    examinaions_to_receive_a_discount_2: "Discount Now!",
    own_package_info:
      "This test is included in custom packages - which you can create yourself at a discount",
  },

  collection_points: {
    filters: {
      is_covid_private: "Adapted for COVID19",
      is_children: "Child-friendly",
      is_40_plus: "Prevention 40+",
      is_ginecology: "Gynecological",
      is_sport: " Sport",
      is_swab: "Swab collection",
      is_parking: "At the lab",
      open_sunday: "Open on Sunday",
      open_saturday: "Open on Saturday",
    },
    additional_info: "Additional information",
    additional_open: "Additional opening hours",
    additional_close: "Point CLOSED",
  },
  footer: {
    _group: " Group",
    usefull_links: "Useful links",
    payment_description:
      "GetLabTest with its registered  at ul. Stępińska 22/30, 00-739 Warsaw, registered in the Register of Entrepreneurs of the National Court Register by the District Court for the Capital City of Warsaw in Warsaw, 13th Commercial Division of the National Court Register, under KRS (National Court Register) no. 0000040890, NIP (Tax Identification Number): 522-000-02-17, REGON: 008105218 (National Business Registry Number), share capital: PLN 1,002,000, having the status of a large business.",
    e_shop: "E-shop",
    online_results: "Online results",
    covid_diagnostics: "COVID-19 Diagnostics",
    patient_information: "Patient information",
    patient_forms: "Patient Forms",
    offer_for_Employers: "Offer for Employers",
    signalist: "Whistleblower",
    tax_strategy: "Tax strategy",
    career: "Careers/Internship",
    for_doctor: "For the doctor",
    survey: "Survey",
    terms_of_service: "Terms",
    privacy_policy: "Privacy Policy",
  },
  who_we_are: {
    history: {
      revolutionizing_healthcare_globally: {
        title: "Revolutionizing Healthcare Globally",
        description:
          "<span class='highlighted-text'>Diagu</span>, an international life sciences <span class='highlighted-text'>AI development company</span>, is committed to transforming healthcare. With a presence across continents, our advanced solutions are bridging the gap between patients, doctors, and laboratories.",
      },
      forging_strong_partnerships: {
        title: "Forging Strong Partnerships",
        description:
          "Founded with a mission to transform healthcare, Diagu has established strong collaborations with leading experts and industry pioneers.",
        sub_description:
          "Our <span class='highlighted-text'>partnerships</span> with <span class='highlighted-text'>Microsoft, Amazon, and Google</span> enhance our innovation and global impact.",
      },
      funding_and_grants: {
        title: "Funding and Grants Validate Our Work",
        description:
          "Our solutions and hard work are validated by investments from <span class='highlighted-text'>renowned funds and grants.</span> This recognition solidifies our credibility, driving our continuous growth and innovation in healthcare technology.",
      },
      pioneering_research: {
        title: "Pioneering Research",
        description:
          "Diagu’s AI algorithms are developed by engineers, doctors, and AI experts. This dedicated research culminated in the creation of the <span class='highlighted-text'>Diagu FIRE, a hybrid AI  solution,</span> a cutting-edge tool providing accurate and efficient diagnostic insights.",
      },
      extending_our_impact: {
        title: "Extending Our Impact",
        description:
          "Building on this success, Diagu continued to expand its horizons. In 2023, the company launched <span class='highlighted-text'>GetLabTest.com</span>, an innovative AI-driven medical laboratory <span class='highlighted-text'>e-commerce platform</span>. This platform unites patients, doctors, and laboratories, reinforcing our commitment to an interconnected healthcare landscape.",
      },
    },
    our_approach_and_technology: {
      title: "Our Approach and Technology",
      machine_learning: {
        title: "Machine learning",
        description:
          "By leveraging machine learning algorithms and deep neural networks, Diagu Fire continually learns and improves, ensuring the most accurate and up-to-date diagnostic insights.",
      },
      ai_system: {
        title: "AI system",
        description:
          "Our AI systems enable physicians to make more informed decisions, streamline workflows, and deliver personalized patient care.",
      },
      full_healthcare_data: {
        title: "Full healthcare data",
        description:
          "Patient diagnostic test results, medical history, treatment regimens, and other relevant healthcare data.",
      },
    },
    diagu_product_portfolio: {
      title: "Diagu Product Portfolio",
      description: {
        param_1:
          "DIAGU offers a diverse range of products that align with our overall business goals of revolutionizing medical diagnosis and treatment through innovative technology solutions.",
        param_2:
          "Our product range encompasses advanced AI-driven systems and platforms designed to enhance healthcare delivery and improve patient outcomes.",
      },
      tabs: {
        tab_1:
          "Empowering healthcare with advanced artificial intelligence, our innovative system analyzes intricate medical data to provide precise diagnostic insights, enabling informed decisions and improved patient outcomes. “Diagu Fire”, our IVD medical product, spearheads this transformative technology.",
      },
    },
    medical_information_security: {
      title: "Complete Security for Medical Information",
      description:
        "At Diagu, we prioritize data security and compliance with industry standards. We adhere to strict privacy protocols to safeguard patient information and ensure confidentiality.",
      who: "World Health Organization",
      pci: "PCI DSS COMPLIANT",
      snomed: "SNOMED International",
      hipaa: "HIPAA COMPLIANT",
      ce: "CE",
      iso: "ISO",
      gdpr: "GDPR",
      hl7: "HL7 FHIR",
    },
    our_partners: {
      title: "Our partners",
      description: "Collaborative Partnerships: Advancing Healthcare Together",
      microsoft_partner: "Microsoft Partner",
      microsoft_for_startups: "Microsoft for Startups",
      ncbr: "NCBR",
      hope: "HOPE",
      nihr: "NIHR",
      google_for_startups: "Google for Startups",
      pioneer: "Pioneer",
      west_midlands: "West Midlands",
      alab_labolatoria: "Alab laboratoria",
      great: "GREAT",
      aws_activate: "aws activate",
      tech_data: "Tech Data",
      uk_trade_investment: "UK TRADE & INVESTMENT",
      ai_w_zdrowiu: "AI W ZDROWIU",
    },
    contact_form: {
      title: "Have questions ?",
      description:
        "Feel free to reach out! We're here to collaborate, innovate, and drive positive change in the healthcare industry. Let's start a conversation and make a difference together.",
      success_submit_message: "Successfully send message",
      submit_btn: "Send",
      inputs: {
        your_name: "Your name",
        business_email: "Business e-mail",
        phone_number: "Phone number",
        company_name: "Company name",
        textarea_placeholder:
          "What Diagu solutions are you interested in? Would you like to know how our system can increase your efficiency?",
        sharing_information_label:
          "I consent to sharing my provided information for communication and to receive relevant updates from Diagu.",
        privacy_policy_label:
          "I have read and agree to the Privacy Policy regarding the use and protection of my personal data submitted through this contact form.",
      },
    },
    footer: {
      for_patient: {
        header: "For patient",
        links: {
          packages: "Packages",
          list_of_tests: "Tests",
          view_results: "View results",
          collection_points: "Diagnostic Centers",
          faq_help_center: "FAQ / Help center",
          patient_terms_of_use: "Patient Terms of Use",
        },
      },
      for_providers: {
        header: "For providers",
        links: {
          offer_for_providers: "Offer for providers",
          faq_help_center: "FAQ / Help center",
          providers_terms_of_use: "Providers Terms of Use",
        },
      },
      about: {
        header: "About",
        links: {
          about_us: "About us",
          contact: "Contact",
          privacy_policy: "Privacy policy",
        },
      },
      social_media: {
        facebook: "Facebook",
        instagram: "Instagram",
        twitter: "Twitter",
        linkedIn: "LinkedIn",
        tiktok: "TikTok",
        crunchbase: "Crunchbase",
        angelists: "Angelists",
        medium: "Medium",
        f6s: "F6S",
      },
    },
  },
  alerts: {
    complete_quiz:
      "Without completing the health questionnaire, the doctor won't be able to describe your test results",
  },

  video: {
    loading: {
      title: "Waiting for connection",
      doctor_title: "Waiting for the doctor",
    },
    microphone: "Microphone",
    speaker: "Speaker",
    camera: "Camera",
    join_to_meeting: "Join",
    no_device: "Empty",
    doctor_leave_title:
      "Video consultation successfully completed by the doctor.",
    doctor_disconnected:
      "The doctor disconnected the video call. Wait for a reconnection or go back to your visits section and rejoin.",
    back_to: "Back to Scheduled visit",
  },

  doctor_call: {
    chat: {
      messages: "Messages",
      doctor: "Doctor",
      patient: "You",
      response: "Answer",
    },
    saved: {
      card: "Appointment card saved.",
      diagnosis: "Diagnosis saved.",
      interview: "Interview saved.",
      recommendations: "Recommendations saved.",
    },
    not_saved: {
      interview: "Interview not saved.",
      recommendations: "Recommendations not saved.",
    },
    add_referral_for_test: "Add referral for a test",
    sure_end_visit: "Are you sure you want to end your visit?",
  },

  visits: {
    specialization: "Specialization",
    doctor: "Doctor",
    meet_type: "Visit type",
    date_from: "From",
    date_to: "to",
    your_visits: "Your visits",
    set_the_date: "Set the date",
    date_can_be_set_after_receiving_results:
      "The date of the visit can be set after receiving the results of the tests",
    status_label: "Status",
    status: {
      waiting_for_results: "Waiting for results",
      canceled_by_doctor: "Canceled by Doctor",
      to_be_scheduled: "To be Scheduled",
      no_show: "No show",
      rescheduled: "Rescheduled",
      scheduled: "Scheduled",
      completed: "Completed",
      ongoing: "Ongoing",
      waiting_for_payment: "Waiting for payment",
    },
  },

  meet_types: {
    meet: "video",
    phone_call: "phone-call",
  },

  doctors: {
    your_doctors: "Your doctors",
    last_visit: "Last visit",
    last_referral: "Last referral",
    upcoming_visit: "Upcoming visit",
    make_an_appointment: "Make an appointment",
    search_your_doctor: "Search your doctor",
    specialization: "Specialization",
  },

  discount_code: {
    realize: "Activate",
    add_code: "Add discount code",
    type_code: "Enter your code",
    code: "Discount code:",
    successful_added: "The code has been activated",
  },

  call: {
    choose_when_we_can_call: "Choose when we can call to you",
  },
  quiz: {
    fill_quiz: "Take a quiz",
    basic_information: "Basic information",
    gender: "Gender",
    weight: "Weight",
    height: "Height",
    age: "Age",
    sex: {
      female: "Female",
      male: "Male",
    },
  },
};
